export default __webpack_public_path__ + "static/media/tete69.f7d885bc.png";